import { Outlet } from 'react-router-dom';

import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import styles from './AppLayout.module.css';

export const AppLayout = () => (
  <div className={styles.layout}>
    <Sidebar />
    <div className={styles.main}>
      <Topbar />
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  </div>
);
